import Vue from 'vue'
import App from './App.vue'
// You can change this import to `import router from './starterRouter'` to quickly start development from a blank layout.
import router from '@/router/router'
import Vuex from 'vuex'
import store from './store'
import axios from 'axios'
import VueCompositionAPI from '@vue/composition-api'
import VueMeta from 'vue-meta'
import NowUiKit from './plugins/now-ui-kit'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false

library.add(faUser, faCheck, faTimes)

Vue.component('font-awesome-icon', FontAwesomeIcon)

axios.defaults.baseURL = 'https://www.beastmodecleanup.com/api'

Vue.config.productionTip = false

Vue.use(VueCompositionAPI)
Vue.use(VueMeta)

Vue.use(NowUiKit)
Vue.use(Vuex)
Vue.use(VueLazyload, {
  preLoad: 1.3, // Preload images 1.3 times the viewport height
  attempt: 1    // Number of attempts to load the image
})

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    // Signal PrerenderSPAPlugin that the app is ready
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
